export default __webpack_public_path__ + "static/media/trener14.eb065364.png";